var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanknotePana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137,45.24l.43.72a4.93,4.93,0,0,0,2,1.88l.75.37-.72.43a4.9,4.9,0,0,0-1.87,2l-.38.76-.43-.72a4.93,4.93,0,0,0-2-1.88l-.75-.37.72-.44a4.91,4.91,0,0,0,1.88-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.08,100.49l.43.72a4.93,4.93,0,0,0,2,1.88l.75.37-.72.43a5,5,0,0,0-1.88,2l-.37.75-.43-.71a4.93,4.93,0,0,0-2-1.88l-.75-.37.72-.44a4.82,4.82,0,0,0,1.87-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.63,254l.43.72a5,5,0,0,0,2,1.88l.76.37-.72.43a5,5,0,0,0-1.88,2l-.37.76-.44-.72a4.91,4.91,0,0,0-2-1.88l-.76-.37.72-.44a4.91,4.91,0,0,0,1.88-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,447.26l.44.72a4.91,4.91,0,0,0,2,1.88l.76.37-.72.44a4.91,4.91,0,0,0-1.88,2l-.37.76-.43-.72a5,5,0,0,0-2-1.88l-.75-.37.72-.44a5,5,0,0,0,1.87-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.09,232.89l1,1.57a10.82,10.82,0,0,0,4.45,4.11l1.65.81-1.57,1a10.82,10.82,0,0,0-4.11,4.45l-.81,1.65-.95-1.57a10.76,10.76,0,0,0-4.45-4.11l-1.65-.81,1.58-.95a10.8,10.8,0,0,0,4.1-4.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.54,32l.95,1.58a10.73,10.73,0,0,0,4.45,4.1l1.65.81-1.58,1a10.8,10.8,0,0,0-4.1,4.45l-.81,1.65-1-1.57a10.78,10.78,0,0,0-4.46-4.11L331.05,39l1.57-.95a10.76,10.76,0,0,0,4.11-4.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.66,423.34l.94,1.58a10.76,10.76,0,0,0,4.46,4.1l1.64.81-1.57.95a10.7,10.7,0,0,0-4.1,4.46l-.82,1.64-.94-1.57a10.75,10.75,0,0,0-4.46-4.1l-1.64-.82,1.57-.94a10.82,10.82,0,0,0,4.1-4.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.14,164.94s-8.07,4-18.62,10.23c-12.86,7.64-39.33,22.65-56.25,10.79l-15.49-30.41s9.94,4.56,25.07,2.59c13.5-1.75,24.3-8.86,29.16-12.13,2-1.33,4.56-3.12,6.59-4.34,3.4-2,7.48-5,13.42-7.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 357.9,
    cy: 170.24,
    rx: 12.41,
    ry: 11.78,
    transform: "translate(-24.01 64.34) rotate(-9.94)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.87,165.45l-1-1.54,1.23-.8,1,1.51a6.42,6.42,0,0,1,3.77-.87l.41,2.12a5.44,5.44,0,0,0-3,.56l1.49,2.3c1.6-.51,3.45-1,4.72,1,.95,1.46.81,3.33-1,4.83l1,1.53-1.23.79-1-1.5a6.06,6.06,0,0,1-3,.76l-.48-2.09a5.41,5.41,0,0,0,2.34-.5l-1.51-2.34c-1.59.52-3.42,1-4.67-1C352,168.8,352.11,167,353.87,165.45Zm.9,3.34c.31.49.83.52,1.5.38l-1.23-1.9A1.16,1.16,0,0,0,354.77,168.79Zm4.25,2,1.26,2a1.22,1.22,0,0,0,.26-1.6C360.23,170.62,359.69,170.6,359,170.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,186.12l.2.12c.5.3,12.57,7.17,34.09-2.62a163,163,0,0,0,23.11-12.89c4.66-3,8-5.21,11.72-6.19l1-.26-13.93-28.62-.79.56c-.23.16-22.94,15.95-33.06,20.09-8,3.29-23.23,8-34.69,2.75l-2.2-1Zm22.94-28.27c7.31-3,20.6-11.63,28-16.62a5.26,5.26,0,0,0,2.94,2.19,5.36,5.36,0,0,0,4-.46l7.63,15.67a4.35,4.35,0,0,0-2.53,2.87,6.27,6.27,0,0,0,.2,3.73c-2,1.1-4.17,2.48-6.68,4.11a159.31,159.31,0,0,1-22.89,12.77c-10.81,4.92-19.09,5.39-24.13,4.92a28.86,28.86,0,0,1-3.91-.63,7.48,7.48,0,0,0-6.44-5.56l-8.13-15.66c.83-.07,1.92-.57,2.13-2.67C331.87,164.54,344,160.68,350.89,157.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.75,61.38s-8.07,4-18.62,10.23C95.27,79.24,68.8,94.26,51.88,82.4L36.39,52s9.94,4.55,25.07,2.59c13.5-1.75,24.3-8.86,29.16-12.14,2-1.32,4.56-3.12,6.59-4.34,3.4-2,7.48-5,13.42-7.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.51,
    cy: 66.67,
    rx: 12.41,
    ry: 11.78,
    transform: "translate(-10.25 15.41) rotate(-9.94)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.48,61.89l-1-1.55,1.23-.79,1,1.51a6.35,6.35,0,0,1,3.77-.87l.41,2.12a5.52,5.52,0,0,0-3,.55l1.49,2.31c1.6-.51,3.45-1,4.72,1a3.5,3.5,0,0,1-1,4.82l1,1.53-1.23.8-1-1.51a6.07,6.07,0,0,1-3,.77l-.48-2.09a5.55,5.55,0,0,0,2.34-.5l-1.51-2.34c-1.59.52-3.42,1-4.67-1C77.58,65.24,77.72,63.39,79.48,61.89Zm.9,3.34c.31.48.83.52,1.5.38l-1.23-1.9A1.16,1.16,0,0,0,80.38,65.23Zm4.25,2,1.26,2a1.24,1.24,0,0,0,.26-1.61C85.84,67.06,85.3,67,84.63,67.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.56,82.56l.2.12c.5.3,12.57,7.17,34.09-2.62A164,164,0,0,0,111,67.17c4.66-3,8-5.21,11.72-6.19l1-.26L109.72,32.1l-.79.56C108.7,32.82,86,48.6,75.87,52.75c-8,3.29-23.23,8-34.69,2.75l-2.2-1ZM76.5,54.29c7.31-3,20.6-11.63,28-16.62a5.19,5.19,0,0,0,6.9,1.73l7.63,15.67a4.33,4.33,0,0,0-2.53,2.87,6.23,6.23,0,0,0,.2,3.72c-2,1.11-4.17,2.49-6.68,4.12A159.31,159.31,0,0,1,87.16,78.55C76.35,83.47,68.07,83.94,63,83.46a29,29,0,0,1-3.91-.62,7.48,7.48,0,0,0-6.44-5.57L44.55,61.61c.83-.06,1.92-.56,2.13-2.67C57.48,61,69.58,57.12,76.5,54.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.87,406.15s-8.07,4-18.62,10.23C382.4,424,355.92,439,339,427.17l-15.49-30.41s9.94,4.56,25.07,2.6c13.5-1.76,24.3-8.87,29.16-12.14,2-1.33,4.56-3.12,6.59-4.34,3.4-2,7.48-5,13.42-7.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.41,413.59c-1.12-6.41,3.44-12.56,10.19-13.75s13.13,3.06,14.25,9.47-3.44,12.56-10.19,13.74S359.53,420,358.41,413.59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.6,406.66l-1-1.54,1.23-.79,1,1.5a6.42,6.42,0,0,1,3.77-.87l.41,2.12a5.54,5.54,0,0,0-3,.56l1.49,2.3c1.6-.51,3.46-1,4.73,1,.94,1.47.8,3.33-1,4.83l1,1.53-1.23.79-1-1.5a6.09,6.09,0,0,1-3,.76l-.48-2.09a5.49,5.49,0,0,0,2.34-.49l-1.51-2.35c-1.59.52-3.42,1-4.67-1C364.7,410,364.84,408.17,366.6,406.66Zm.9,3.35c.31.48.84.51,1.5.38l-1.23-1.91A1.19,1.19,0,0,0,367.5,410Zm4.25,2,1.27,1.95a1.23,1.23,0,0,0,.25-1.6C373,411.84,372.42,411.81,371.75,412Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.68,427.33l.2.12c.51.3,12.57,7.17,34.09-2.61a163.22,163.22,0,0,0,23.11-12.9c4.66-3,8-5.21,11.72-6.19l1-.26-13.93-28.61-.8.55c-.23.16-22.93,15.95-33.06,20.09-8,3.29-23.23,8-34.69,2.75l-2.19-1Zm22.94-28.27c7.31-3,20.6-11.63,28-16.62a5.19,5.19,0,0,0,6.9,1.73l7.63,15.67a4.38,4.38,0,0,0-2.53,2.87,6.26,6.26,0,0,0,.21,3.73c-2,1.11-4.18,2.49-6.68,4.11a160.94,160.94,0,0,1-22.9,12.78c-10.81,4.91-19.09,5.38-24.13,4.91a28.69,28.69,0,0,1-3.9-.63,7.5,7.5,0,0,0-6.44-5.56l-8.13-15.66c.83-.06,1.91-.56,2.12-2.67C344.61,405.75,356.7,401.9,363.62,399.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.47,312.2s-8.06,4-18.61,10.23C81,330.06,54.53,345.08,37.61,333.22L22.12,302.81s9.94,4.56,25.07,2.59c13.49-1.75,24.3-8.86,29.16-12.14,2-1.32,4.55-3.12,6.59-4.33,3.4-2,7.47-5,13.42-7.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,319.64c-1.12-6.41,3.44-12.57,10.19-13.75s13.13,3.05,14.26,9.46S78,327.92,71.27,329.1,58.14,326.05,57,319.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2,312.71l-1-1.55,1.23-.79,1,1.51a6.42,6.42,0,0,1,3.77-.87l.4,2.12a5.5,5.5,0,0,0-3,.55L69.05,316c1.61-.51,3.46-1,4.73,1,.94,1.46.8,3.33-1,4.83l1,1.53-1.23.79-1-1.51a6,6,0,0,1-3,.77l-.47-2.09a5.55,5.55,0,0,0,2.34-.5l-1.51-2.34c-1.6.52-3.42,1-4.68-1C63.31,316.06,63.44,314.21,65.2,312.71Zm.9,3.34c.32.48.84.52,1.5.38l-1.22-1.9A1.17,1.17,0,0,0,66.1,316.05Zm4.26,2,1.26,2a1.22,1.22,0,0,0,.25-1.61C71.56,317.88,71,317.86,70.36,318Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.28,333.38l.21.12c.5.3,12.57,7.17,34.09-2.62A163,163,0,0,0,96.69,318c4.66-3,8-5.21,11.72-6.19l1-.26L95.45,282.92l-.79.56c-.23.16-22.94,15.94-33.06,20.09-8,3.29-23.23,8-34.69,2.75l-2.2-1Zm22.95-28.27c7.31-3,20.6-11.63,28-16.62a5.2,5.2,0,0,0,6.91,1.73l7.62,15.67a4.32,4.32,0,0,0-2.52,2.87,6.19,6.19,0,0,0,.2,3.73c-2,1.1-4.17,2.48-6.68,4.11a159.31,159.31,0,0,1-22.89,12.77c-10.81,4.92-19.09,5.39-24.14,4.92a29,29,0,0,1-3.9-.63,7.5,7.5,0,0,0-6.44-5.57l-8.13-15.66c.83-.06,1.91-.56,2.13-2.67C43.21,311.8,55.3,307.94,62.23,305.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.33,317.19s15.45-18.11,45.82-6.45a18.54,18.54,0,0,0,3.56,1,19.74,19.74,0,0,0,10.37-.74c5.91-2.38,14.33-5.85,14.33-5.85l26,15.4s-10.91,8-21.47,8.62-23-8-35.16-5a30.4,30.4,0,0,0-16,9.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,321.18c-1.17,1-8.21.08-15.73-2.15s-12.68-4.89-11.51-5.94,8.22-.09,15.74,2.15S425.21,320.13,424,321.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.55,319.14l.48.51-1.58-.35-.47-.49a39.66,39.66,0,0,1-4.28-1.23l.35-.36a31.73,31.73,0,0,0,3.37,1l-.71-.75c-1.87-.51-4-1.11-4.6-1.76-.46-.47.37-.62,2.79-.15l-.47-.5,1.58.35.47.49c1.21.29,2.45.63,3.47,1l-.27.38c-.93-.31-1.82-.56-2.64-.76l.73.76c1.86.51,4,1.1,4.56,1.73C416.77,319.46,416,319.6,413.55,319.14Zm-3.47-2.34-.61-.64c-.78-.13-1-.07-.85.08A4.41,4.41,0,0,0,410.08,316.8Zm3.75,1.69a4.34,4.34,0,0,0-1.43-.56l.59.62C413.73,318.67,414,318.63,413.83,318.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.06,307l-.28.14A91.28,91.28,0,0,1,419.57,313c-3.63.92-5.33.63-8.43.09-.6-.1-1.25-.22-2-.33a41.47,41.47,0,0,1-5.34-1.49c-3.93-1.27-8.82-2.84-13.71-3H390c-.14,0-13.61-1.15-24.53,7.64l-.66.52,23.38,14.15.32-.29c.13-.12,12.67-11.45,29.62-7.18,2,.5,3.87,1,5.62,1.46,13.74,3.63,20.63,5.45,34.43-2.84l.85-.51Zm-11,16.39c-1.75-.47-3.62-1-5.63-1.47-11.53-2.9-21.08,1.16-26.33,4.33a6.31,6.31,0,0,0-7.56.7l-13.67-8.28c2.64-2.3,1.1-4.29.2-5.11a37.33,37.33,0,0,1,18.87-4.17c4.8.14,9.65,1.69,13.54,2.94a40.72,40.72,0,0,0,5.52,1.53l2,.33c3.15.55,5.05.88,8.92-.1A81.37,81.37,0,0,0,431.35,310c1,.85,3.55,2.45,7.38.53l13.95,8.25c-1,.5-2.61,1.78-.12,4.59C442.29,328.22,435.67,326.48,424,323.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,187.89s-.25-23.81,30.31-35a18.29,18.29,0,0,0,3.35-1.58A19.55,19.55,0,0,0,167,144c2.9-5.68,7-13.82,7-13.82l29.73-5.49s-3,13.17-10.52,20.61-22.63,9.11-29.81,19.3a30.43,30.43,0,0,0-6,17.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.92,149.69c-.19,1.56-6.14,5.46-13.28,8.72s-12.76,4.64-12.57,3.08,6.14-5.47,13.28-8.72S176.11,148.13,175.92,149.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.67,155.05l.7.07-1.42.77-.68-.06a43.37,43.37,0,0,1-4,1.89l0-.5a33.58,33.58,0,0,0,3.19-1.47l-1-.1c-1.75.85-3.74,1.79-4.62,1.7-.66-.06-.13-.71,2-1.95l-.69-.06,1.42-.78.67.06c1.11-.58,2.27-1.13,3.27-1.54l0,.46c-.91.38-1.75.78-2.5,1.16l1.05.1c1.74-.84,3.7-1.77,4.58-1.69C169.31,153.18,168.79,153.82,166.67,155.05Zm-4.15.51-.88-.08c-.68.42-.8.6-.59.62A4.58,4.58,0,0,0,162.52,155.56Zm3.93-1.19a4.55,4.55,0,0,0-1.45.52l.86.08C166.5,154.58,166.65,154.39,166.45,154.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.93,131.78l-.12.29a91.82,91.82,0,0,1-7.65,14.37c-2.13,3.08-3.61,4-6.3,5.61l-1.71,1a41,41,0,0,1-5,2.38c-3.8,1.63-8.51,3.66-12.3,6.76l-.09.07c-.11.08-11,8.07-13.48,21.87l-.15.83L155,180.32l.05-.44c0-.17,2-16.95,17.61-24.87,1.85-.94,3.58-1.79,5.2-2.59C190.64,146.13,197,143,202,127.66l.31-.93Zm2.45,19.59c-1.62.8-3.36,1.66-5.2,2.6-10.6,5.39-15.14,14.72-17,20.56a6.3,6.3,0,0,0-5.24,5.49l-15.75,2.74c.48-3.46-2-3.95-3.2-4a37.25,37.25,0,0,1,11.48-15.54c3.71-3.05,8.38-5.07,12.14-6.68a41.22,41.22,0,0,0,5.17-2.47c.62-.39,1.18-.73,1.7-1,2.73-1.66,4.38-2.66,6.65-5.94a80.88,80.88,0,0,0,6-10.63c1.29,0,4.29-.49,5.91-4.45L196,129.09c-.46,1-.8,3,2.92,3.54C194.3,143,188.17,146.05,177.38,151.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.39,84.35S362,65.52,392.86,75.72a19.21,19.21,0,0,0,3.6.84,19.66,19.66,0,0,0,10.32-1.23c5.79-2.66,14-6.53,14-6.53l26.73,14.14s-10.52,8.46-21,9.64-23.4-6.89-35.35-3.36a30.44,30.44,0,0,0-15.55,10Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.23,85.33c-1.12,1.1-8.21.48-15.83-1.39s-12.89-4.28-11.77-5.38,8.2-.48,15.82,1.39S411.35,84.23,410.23,85.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.65,83.8l.5.48L398.56,84l-.49-.47a38.22,38.22,0,0,1-4.34-1l.33-.37c1,.29,2.24.6,3.42.83l-.75-.72c-1.89-.42-4-.91-4.68-1.53-.48-.45.34-.64,2.79-.28l-.5-.48,1.59.27.49.47c1.23.23,2.48.51,3.52.81l-.25.4c-.94-.27-1.85-.48-2.67-.64l.76.73c1.89.41,4,.9,4.63,1.51C402.88,84,402.07,84.15,399.65,83.8Zm-3.58-2.17-.64-.61c-.79-.09-1,0-.85.12A4.69,4.69,0,0,0,396.07,81.63Zm3.83,1.5a4.62,4.62,0,0,0-1.46-.49l.62.59C399.81,83.32,400,83.27,399.9,83.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.55,70.67l-.27.15a92.35,92.35,0,0,1-14.91,6.53c-3.59,1.09-5.3.88-8.42.49l-2-.24a40.78,40.78,0,0,1-5.41-1.23c-4-1.08-8.95-2.41-13.84-2.33h-.12c-.14,0-13.64-.5-24.14,8.8l-.62.55,24,13,.31-.31c.12-.12,12.11-12,29.24-8.59,2,.41,3.92.81,5.69,1.19,13.89,3,20.86,4.46,34.25-4.48l.82-.55ZM410.33,87.56c-1.77-.38-3.66-.79-5.69-1.2C393,84,383.63,88.53,378.54,92A6.31,6.31,0,0,0,371,93l-14-7.62c2.52-2.42.88-4.33-.05-5.11a37.37,37.37,0,0,1,18.65-5.07c4.8-.09,9.71,1.22,13.66,2.29a42.1,42.1,0,0,0,5.59,1.27l2,.23a17.67,17.67,0,0,0,8.9-.53A80,80,0,0,0,417,73.84c1,.79,3.67,2.27,7.4.18l14.32,7.57c-1,.54-2.51,1.9.1,4.59C428.78,91.5,422.1,90.07,410.33,87.56Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.8,478.78c0,.14-94.39.26-210.79.26s-210.81-.12-210.81-.26,94.37-.26,210.81-.26S464.8,478.64,464.8,478.78Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.25,265.43l.63,1.05a7.2,7.2,0,0,0,3,2.74l1.1.54-1.05.63a7.2,7.2,0,0,0-2.74,3l-.54,1.1-.63-1a7.2,7.2,0,0,0-3-2.74l-1.1-.54,1.05-.63a7.2,7.2,0,0,0,2.74-3Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.46,460.89l.61,1a7,7,0,0,0,2.88,2.66l1.07.52-1,.61a7,7,0,0,0-2.65,2.89l-.53,1.06-.61-1a7,7,0,0,0-2.88-2.65l-1.07-.53,1-.61a7.1,7.1,0,0,0,2.66-2.88Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.13,127.88l1.1,1.83a12.54,12.54,0,0,0,5.18,4.77l1.91,1-1.82,1.1a12.42,12.42,0,0,0-4.77,5.18l-1,1.91-1.1-1.83A12.48,12.48,0,0,0,73.5,137l-1.91-1,1.83-1.1a12.58,12.58,0,0,0,4.77-5.17Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,63.87l1.1,1.83a12.48,12.48,0,0,0,5.18,4.77l1.91,1-1.83,1.1a12.48,12.48,0,0,0-4.77,5.18l-.94,1.91-1.1-1.83A12.6,12.6,0,0,0,294.37,73l-1.92-1,1.83-1.1a12.48,12.48,0,0,0,4.77-5.18Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,224.43l.43.71a4.93,4.93,0,0,0,2,1.88l.75.37-.72.44a4.91,4.91,0,0,0-1.88,2l-.37.76-.43-.72a4.93,4.93,0,0,0-2-1.88l-.75-.37.72-.43a5,5,0,0,0,1.88-2Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.69,220.27l.45.74a5,5,0,0,0,2.1,1.94l.78.38-.75.45a5.08,5.08,0,0,0-1.93,2.1l-.39.78-.44-.75a5.08,5.08,0,0,0-2.1-1.93l-.78-.38.74-.45a5,5,0,0,0,1.94-2.1Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.91,90.26l.45.74a5.17,5.17,0,0,0,2.1,1.94l.77.38-.74.45a5.08,5.08,0,0,0-1.93,2.1l-.39.77-.44-.74A5.1,5.1,0,0,0,172.62,94l-.77-.39.74-.44A5.2,5.2,0,0,0,174.53,91Z",
    style: {
      fill: "#35A464"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.39,321.33c0,1.07,6.45,29.54,6.45,29.54s13.43-9.13,18.53-13.43,29.81-27.12,29.81-27.12L418,324s-49,66.65-66.35,70.66c-8.91,2.05-18.79-4.68-20.71-9.44C326.61,374.6,320,329.34,320,329.34l9.61-4.25Z",
    style: {
      fill: "#ba7e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.41,350.93a16.49,16.49,0,0,0-3.05.8,12.66,12.66,0,0,0-5.58,4.94,27.63,27.63,0,0,0-2.89,7.05,22.28,22.28,0,0,1-.94,3.06,16.68,16.68,0,0,1,.57-3.16,24.12,24.12,0,0,1,2.8-7.24,12.26,12.26,0,0,1,5.9-5,7.94,7.94,0,0,1,2.32-.49A2.4,2.4,0,0,1,355.41,350.93Z",
    style: {
      fill: "#875149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.26,313.94s13.5-15.12,18.95-14.69,13.28,1.61,15.46,1.24a59.3,59.3,0,0,1,8.27,0s14.15-7.66,16.76-7.06c0,0,2.43-.13,3.27,1.25,0,0,5.38-3.41,9.26-1.29l-14.1,11.75,4.3-.54s12.67-6.7,16.68-2.09l-9.57,5.14s7.95-.12,9.15,3.11l-17.81,2.86s-33.84,2.83-35.63,3.61-8.95,10-8.95,10Z",
    style: {
      fill: "#ba7e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.16,294.75a4.79,4.79,0,0,1-.85.83c-.57.5-1.41,1.21-2.49,2a81.53,81.53,0,0,1-8.81,5.95c-1.71,1-3.33,1.91-4.91,2.64a6.66,6.66,0,0,1-4.6.62l.25-.14a4,4,0,0,1-2.52,2.56,3.41,3.41,0,0,1-1,.18c-.23,0-.34,0-.34,0a10.48,10.48,0,0,0,1.24-.35,3.89,3.89,0,0,0,2.21-2.46l.06-.2.19.06a6.35,6.35,0,0,0,4.28-.69c1.52-.73,3.16-1.67,4.84-2.65,3.57-2.08,6.66-4.2,8.86-5.79l2.59-1.9A5.24,5.24,0,0,1,462.16,294.75Z",
    style: {
      fill: "#875149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.13,305.41a6.64,6.64,0,0,1-1.89,1.47,16.27,16.27,0,0,1-5.38,2.08c-1.12.22-2.2.26-3.13.43a8.29,8.29,0,0,0-2.35.84,4.09,4.09,0,0,1-2.3.66,17.8,17.8,0,0,0,2.12-1,7.9,7.9,0,0,1,2.44-1c1-.21,2-.26,3.11-.48A24.79,24.79,0,0,0,457.13,305.41Z",
    style: {
      fill: "#875149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.28,306.64a8.09,8.09,0,0,1-1.92,1.48,22.21,22.21,0,0,1-11.09,3.35,8,8,0,0,1-2.42-.17,40.85,40.85,0,0,0,8-1.29C466.2,308.73,469.18,306.48,469.28,306.64Z",
    style: {
      fill: "#875149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.82,402c-14.61,22.74-31.57,51.19-41.9,76.82h176l-21-76.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.84,318.81s12.43,18.23,16.65,23,22,30.27,31.25,40.48,19.34,15.83,25.87,15.83c6.7,0,13.48-2.29,18.8-14.78,7.68-18,14.15-71,14.15-71l-30-11-10.9,54.88h0c-2.93-2.92-49.16-46-49.16-46L93.9,314.62Z",
    style: {
      fill: "#ba7e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.28,296.35s.71-1.27,4.66-.7,10.88,4.66,12.43,4.66,18.92.56,22.31,1.41,8.66,1.36,11.76,4.6l5,4.46L88.67,320a6.93,6.93,0,0,0-5.36-2.77C79.5,317,62,316.12,62,316.12L48.44,313l-17.23-8.33a4.32,4.32,0,0,1,4.94-2.55c3.53.85,10.17,3.25,10.17,3.25l5.79,1.77-15.25-7.28a7.45,7.45,0,0,1,7.76-1.83c4.8,1.55,13,5.22,13,5.22l1.13-.42Z",
    style: {
      fill: "#ba7e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.34,306.38a11.06,11.06,0,0,1-5.16-.84,11.06,11.06,0,0,1-4.48-2.71c.09-.13,2,1.26,4.65,2.23S68.35,306.23,68.34,306.38Z",
    style: {
      fill: "#875149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.15,310.75a6.9,6.9,0,0,1-2.25.17,19.87,19.87,0,0,1-10.32-3.19,7.35,7.35,0,0,1-1.77-1.41,35.71,35.71,0,0,0,6.86,3.23A35.53,35.53,0,0,0,65.15,310.75Z",
    style: {
      fill: "#875149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.92,306.5A3.38,3.38,0,0,0,33,309.69a100.72,100.72,0,0,0,17.58,4.05",
    style: {
      fill: "#875149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.24,379.37c-.11,0,.1-1.52-.06-4a25.89,25.89,0,0,0-.63-4.22,28.63,28.63,0,0,0-1.7-4.93,27.93,27.93,0,0,0-2.64-4.5,25.91,25.91,0,0,0-2.79-3.23c-1.75-1.7-3-2.53-3-2.61a4.06,4.06,0,0,1,.93.54,7.91,7.91,0,0,1,1,.74c.38.31.84.64,1.28,1.07a23.72,23.72,0,0,1,2.92,3.21,24.8,24.8,0,0,1,4.42,9.61,23.77,23.77,0,0,1,.53,4.31,15.09,15.09,0,0,1,0,1.66,8.29,8.29,0,0,1-.11,1.25A4.5,4.5,0,0,1,164.24,379.37Z",
    style: {
      fill: "#875149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.92,248.19c-4.15,2.56-13.74,10.33-23.66,31.33-13.21,27.93-16.64,45.36-16.64,45.36l35.11,12.54,10.64-91.86S194.29,247.35,192.92,248.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.3,277.45s.83,29.64.83,37.69,3.6,68.59,3.6,68.59,0,19.92,12.37,19.61,33.52,2.09,41.89,2.09c6.17,0,41.24.41,59.7-1.24,8.75-.78,12.12-5.05,14.82-12,.36-.94.14-.39.36-.94,5.29-13,1.2-68.63,1.2-68.63l-6.55-50.29L298.6,242.66l-84.51-.27C187,244.25,187,255.37,185.3,277.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.93,267c-13.92-23.1-35.33-24.3-35.33-24.3l12.64,104.17,10-2.78c.74-.25,37.5-14.91,37.5-14.91S342.49,281.18,333.93,267Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.13,274.44s.05.06.13.2.19.37.31.62c.26.54.68,1.34,1.15,2.4,1,2.1,2.24,5.21,3.57,9.13a140.6,140.6,0,0,1,6.46,31.63,292.53,292.53,0,0,1,1,32.3c-.07,4.13-.17,7.47-.25,9.78,0,1.12-.08,2-.1,2.66,0,.28,0,.51,0,.7a.89.89,0,0,1,0,.23,1.1,1.1,0,0,1,0-.24v-.69c0-.65,0-1.54,0-2.66,0-2.36,0-5.69.08-9.79a321.43,321.43,0,0,0-1.13-32.24,146.89,146.89,0,0,0-6.29-31.57c-1.28-3.92-2.5-7-3.41-9.16-.43-1.07-.82-1.88-1-2.44l-.27-.64A1.63,1.63,0,0,1,309.13,274.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.66,343.24a40.47,40.47,0,0,1,15.84-9.8c7.9-2.55,31.3-7.43,37.51-9.71a52,52,0,0,0,18.31-11.56l27.47,22.56a84.81,84.81,0,0,1-15.62,11.1c-8.84,4.75-30.63,4.77-42.36,11.81-7.6,4.56-17.44,17.91-17.44,17.91Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285.47,465.32a40.51,40.51,0,0,1-17.73-5.72c-7.07-4.36-25.94-19-31.7-22.27a72.76,72.76,0,0,0-20.7-7.75l-.59-34.25a84.67,84.67,0,0,1,18.57,4.7c9.35,3.66,23.48,20.24,36.45,24.62,8.39,2.83,24.94,1.67,24.94,1.67Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.65,293.56c7,2.36,15.86-1.65,20.35-7.52s8.88-13.39,9.95-20.7c-5.13,0-12.1.38-17.23.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M187,301.62a4.35,4.35,0,0,1,.06.82l.09,2.36c.06,2.1.14,5.06.24,8.69.2,7.37.47,17.48.76,28.65s.68,21.31,1,28.64c.18,3.63.32,6.58.42,8.68,0,1,.08,1.77.11,2.36a7.24,7.24,0,0,1,0,.82,4.14,4.14,0,0,1-.11-.82c-.06-.58-.13-1.37-.21-2.35-.19-2-.37-5-.59-8.67-.42-7.33-.83-17.46-1.16-28.65s-.51-21.32-.61-28.66c0-3.63-.05-6.58-.07-8.69,0-1,0-1.77,0-2.36A4.7,4.7,0,0,1,187,301.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.92,363.6C178.78,343,180.14,320,187,298.5c1,20.95,1.46,44.13.95,65.1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M297,143.69a29.52,29.52,0,0,0-14.62-17.46c-7.63-3.89-16.73-4.22-25.08-2.3s-16.06,5.95-23.35,10.45c-4.09,2.52-8.16,5.28-11,9.13-5.26,7-10.33,18.45-10.61,27.22-.22,7.09,3,24.73,6.17,31.07,1.13,2.26,3.78,4.25,7,5.93a60.08,60.08,0,0,0,13.31,16.6q2.25-7.2,4.51-14.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.62,135.08l-14-2.1c8.14,17.94,11.4,59.41,16.31,78.49,4.93-7.61,16.22-30.67,15.32-39.69S309.15,133.06,292.62,135.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.35,167.19c.45-10.63,7.07-19.53,17.3-22.45l31.89-9.11c13.84-1.9,23.59,14.92,24.9,28.82,1.45,15.45,2.54,31.77,1.06,43.38-3,23.34-20.68,26.85-20.68,26.85s.31,11,.49,17.83L263.39,292,234,244.68l-6.69-77.2C227.25,167.08,227.33,167.72,227.35,167.19Z",
    style: {
      fill: "#ba7e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55,181.51a3,3,0,0,1-2.78,3.1,2.86,2.86,0,0,1-3.16-2.59,3,3,0,0,1,2.78-3.1A2.86,2.86,0,0,1,292.55,181.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21,173.65c-.35.4-2.66-1.2-5.87-1.09s-5.5,1.78-5.86,1.4c-.18-.17.18-.88,1.18-1.66a8.16,8.16,0,0,1,4.68-1.6,7.78,7.78,0,0,1,4.68,1.36C298,172.78,298.39,173.47,298.21,173.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.87,181.52a3,3,0,0,1-2.78,3.09,2.86,2.86,0,0,1-3.16-2.59,3,3,0,0,1,2.78-3.1A2.86,2.86,0,0,1,264.87,181.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.77,174.52c-.36.4-2.67-1.2-5.87-1.09s-5.51,1.78-5.87,1.4c-.17-.17.18-.88,1.18-1.66a8.19,8.19,0,0,1,4.68-1.6,7.88,7.88,0,0,1,4.69,1.35C267.59,173.65,267.94,174.34,267.77,174.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.51,199.41c0-.18,2-.58,5.18-1.1.81-.11,1.58-.29,1.7-.85a4.09,4.09,0,0,0-.62-2.41l-2.61-6.16c-3.63-8.77-6.29-16-5.94-16.14s3.59,6.85,7.22,15.62l2.52,6.2a4.79,4.79,0,0,1,.52,3.2,2.06,2.06,0,0,1-1.31,1.24,5.08,5.08,0,0,1-1.38.23C280.54,199.52,278.53,199.6,278.51,199.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.77,227.29s8,15.74,31.2,12.85l-.15-5.46A58.57,58.57,0,0,1,250.77,227.29Z",
    style: {
      fill: "#875149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.43,163c-.29.88-3.5.56-7.25,1.13s-6.75,1.69-7.28.92c-.23-.36.27-1.2,1.47-2.08a12.79,12.79,0,0,1,11.07-1.57C265.84,161.89,266.55,162.55,266.43,163Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.89,163.88c-.54.74-2.78.06-5.43.1s-4.89.64-5.43-.1c-.24-.37.09-1.11,1.05-1.83a7.64,7.64,0,0,1,4.38-1.33,7.53,7.53,0,0,1,4.37,1.34C296.79,162.77,297.13,163.51,296.89,163.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.52,143.42c-1.52-3.46-5.41-5.45-9.18-5.53s-7.42,1.45-10.63,3.43c-13.61,8.39-20.17,27.91-33.6,36.57-3.3,2.13-7.73.39-10.52,3.17s-4.51,7.14-2.83,10.69a32.88,32.88,0,0,1-5-7.89,11,11,0,0,1,.13-9.06c1.12-2.08,3.17-3.71,3.67-6,.45-2-.41-4.12-.38-6.21a13.52,13.52,0,0,1,2-6c5.08-9.63,12.21-18.4,21.54-24A39.4,39.4,0,0,1,270,126.74a30.09,30.09,0,0,1,19.61,7.14c3.14,2.77,6.44,5.62,5,9.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,183.93c-.26-.66-12.5-4.69-12.3,8.2.2,12.52,12.76,9.69,12.77,9.33S231,183.93,231,183.93Z",
    style: {
      fill: "#ba7e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.53,196.79c-.05,0-.21.16-.58.34a2.2,2.2,0,0,1-1.63.06c-1.33-.46-2.48-2.54-2.59-4.79a7.32,7.32,0,0,1,.55-3.13,2.53,2.53,0,0,1,1.61-1.71,1.12,1.12,0,0,1,1.3.57c.17.35.1.6.17.62s.26-.21.15-.73a1.38,1.38,0,0,0-.51-.77,1.63,1.63,0,0,0-1.21-.3,3.07,3.07,0,0,0-2.24,2,7.36,7.36,0,0,0-.69,3.5c.13,2.52,1.47,4.86,3.29,5.34a2.27,2.27,0,0,0,2-.37C227.51,197.1,227.58,196.82,227.53,196.79Z",
    style: {
      fill: "#875149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.85,177.64a3.87,3.87,0,0,0,.74-.44c.47-.32,1.2-.75,2.06-1.39a42.93,42.93,0,0,0,6.58-6.35,118.74,118.74,0,0,0,8-11,97.61,97.61,0,0,1,10-13.16,39,39,0,0,1,6.51-5.45,32.33,32.33,0,0,1,7.1-3.47,35.69,35.69,0,0,1,13.21-2,34.08,34.08,0,0,1,8.93,1.49c1,.28,1.81.61,2.34.79a5.42,5.42,0,0,0,.83.27,4.08,4.08,0,0,0-.78-.37,19,19,0,0,0-2.32-.9,32.34,32.34,0,0,0-9-1.68,35.26,35.26,0,0,0-13.4,1.91,32.25,32.25,0,0,0-7.23,3.5,39.4,39.4,0,0,0-6.63,5.53,96.56,96.56,0,0,0-10,13.25,129.1,129.1,0,0,1-7.83,11,46.26,46.26,0,0,1-6.4,6.43c-.84.67-1.54,1.13-2,1.47A5.61,5.61,0,0,0,225.85,177.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.17,199.05a2.46,2.46,0,1,0,.59.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.76,199.22a3.35,3.35,0,0,1,1.18,1.64,2.12,2.12,0,0,1-.44,2,2.18,2.18,0,0,1-3.88-1.11,2.14,2.14,0,0,1,.68-1.91,3.3,3.3,0,0,1,1.87-.77s-.19-.13-.59-.12a2.61,2.61,0,0,0-2.48,2.87,2.68,2.68,0,0,0,4.8,1.38,2.46,2.46,0,0,0,.42-2.43,2.54,2.54,0,0,0-1-1.32C227,199.21,226.77,199.19,226.76,199.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1,181.09c-.1,3.43-.16,7,1.51,10s5.71,4.94,8.63,3.16c2.38-1.45,3-4.58,3.35-7.35,1-8,1.28-16.08,2.3-24.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.27,137.55c0,.08-1.11-.17-3.11-.18a21.31,21.31,0,0,0-8.24,1.75,27,27,0,0,0-5.11,2.82,57.37,57.37,0,0,0-5.24,4.24,64.19,64.19,0,0,0-10.15,11.59c-1.53,2.28-2.87,4.61-4.34,6.78a31.81,31.81,0,0,1-4.85,5.79,56.07,56.07,0,0,1-10.37,7.37c-3.16,1.78-5.8,3-7.62,3.92l-2.11,1a3.61,3.61,0,0,1-.76.3,3.19,3.19,0,0,1,.69-.43l2.06-1.09c1.78-.94,4.38-2.27,7.49-4.1a57.68,57.68,0,0,0,10.18-7.42,31.74,31.74,0,0,0,4.72-5.69c1.44-2.15,2.78-4.49,4.32-6.79a62.78,62.78,0,0,1,10.31-11.68,52.91,52.91,0,0,1,5.34-4.24,26.93,26.93,0,0,1,5.25-2.8,20.5,20.5,0,0,1,8.43-1.56,14.4,14.4,0,0,1,2.32.25A3.67,3.67,0,0,1,291.27,137.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.53,173.37a5.41,5.41,0,0,1-1.08.78l-3.12,1.95-1.05.65a3.49,3.49,0,0,1-1.36.49,1.28,1.28,0,0,1-.85-.18,1.06,1.06,0,0,1-.49-.81,2.77,2.77,0,0,1,.55-1.6c1.07-1.84,2.25-3.85,3.51-6l.51.45a13.27,13.27,0,0,1-4,2.12,13,13,0,0,1-4.46.65,3.78,3.78,0,0,1-1.14-.16,1.57,1.57,0,0,1-1-.82,1.34,1.34,0,0,1,.18-1.27,5.11,5.11,0,0,1,.69-.8,26.49,26.49,0,0,0,4.1-5.5,43.14,43.14,0,0,0,2.55-5.84,6.61,6.61,0,0,1-.35,1.7,23.07,23.07,0,0,1-1.76,4.38,25.36,25.36,0,0,1-4.08,5.71c-.45.45-.9,1-.71,1.36s.88.57,1.54.55a12.57,12.57,0,0,0,8-2.63l1.46-1.13-1,1.58-3.59,6a2.4,2.4,0,0,0-.49,1.24c0,.35.33.55.73.51a6.52,6.52,0,0,0,2.22-1l3.22-1.78A6.27,6.27,0,0,1,228.53,173.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.48,205.67a4.21,4.21,0,0,1,4.24-3.3,4.41,4.41,0,0,1,3.43,2.3,5.42,5.42,0,0,1,.31,4.18l-.06.3a4.75,4.75,0,0,1-5.33,1.29A4.45,4.45,0,0,1,266.48,205.67Z",
    style: {
      fill: "#875149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,210.22s-.13.34-.64.64a3.49,3.49,0,0,1-2.45.37,4.27,4.27,0,0,1-2.88-2.32,5.86,5.86,0,0,1,1.25-6.52,2.69,2.69,0,0,1,2.3-.66,8.26,8.26,0,0,1,3.16,1.78c1.57,1.19,2.5,2,2.42,2.1s-1.16-.46-2.84-1.49a8.81,8.81,0,0,0-2.89-1.44,1.71,1.71,0,0,0-1.47.47,4.76,4.76,0,0,0-1,1.63,4.69,4.69,0,0,0,0,3.71,3.58,3.58,0,0,0,2.19,2,3.53,3.53,0,0,0,2.11,0C271.68,210.34,271.94,210.16,272,210.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Banknotes--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.82,186.67a41.91,41.91,0,0,1,15.57,11.38c5.53,6.59,19.32,27.14,23.93,32.21a53.9,53.9,0,0,0,18.22,13.07L395.6,278.47a87.7,87.7,0,0,1-16.73-10.66c-8-6.63-16.51-27.53-27.84-36.05-7.33-5.51-24-9.75-24-9.75Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.41,244.38h0c-.1-.07-11-6.24-15.62-11.37-3.27-3.61-8.31-10.47-13.19-17.11-3.69-5-7.18-9.78-9.81-13-8.4-10.3-15.09-12.38-15.37-12.46l-.65-.2-19,29.66,1.19.32c.12,0,12.39,3.35,18.18,7.58,7.71,5.63,12.16,13.12,16.47,20.36,3.08,5.18,6,10.07,10,14.35a68.71,68.71,0,0,0,11.86,10.11,46.18,46.18,0,0,0,5.39,3.16l.94.43Zm-53.25-18c-3.45-2.52-8.87-4.67-13-6.08a4.63,4.63,0,0,0,1-3.08c-.48-1.81-2-2.18-3.57-1.45l12.38-19.26.1.15c1.91,2.68,5.65.37,5.9-2.39a1.37,1.37,0,0,0,.2.13A47.42,47.42,0,0,1,364.39,204c2.6,3.19,6.08,7.92,9.76,12.94.43.57.85,1.15,1.27,1.72-2.82-1.3-6.54-.68-10.05,4.24-3.24,4.56-3.7,10.71-2.85,15.41A49,49,0,0,0,351.16,226.34Zm26.71,34.93c-3.87-4.14-6.73-8.95-9.76-14l-.86-1.45a9.7,9.7,0,0,0,11-4.13c2.34-3.93,4.58-9.56,3-15.22,2.38,3.13,4.56,5.89,6.27,7.79,3.27,3.6,8.9,7.88,12.28,10.33a2,2,0,0,0-1.36,2.55c.22,1.11,1.26,2.48,2.52,2.21l.17-.07-6.5,21.39c-1-3-4.31-1.6-3.79,1.35A66.61,66.61,0,0,1,377.87,261.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.36,238.92l-1.15,1.83-1.46-.91,1.12-1.79a7.53,7.53,0,0,1-2.82-3.59l2.05-1.5a6.56,6.56,0,0,0,2.11,2.94l1.71-2.74c-1.34-1.45-2.77-3.19-1.31-5.54,1.09-1.74,3.15-2.53,5.64-1.38l1.14-1.82,1.46.91-1.12,1.79a7.18,7.18,0,0,1,2.35,2.86l-2,1.56a6.44,6.44,0,0,0-1.7-2.26l-1.74,2.79c1.35,1.45,2.76,3.17,1.31,5.48C373.89,239.26,371.85,240,369.36,238.92Zm3.12-2.64c.36-.58.13-1.15-.35-1.79l-1.41,2.26A1.38,1.38,0,0,0,372.48,236.28Zm-.05-5.53,1.46-2.33a1.45,1.45,0,0,0-1.84.54C371.69,229.53,371.93,230.12,372.43,230.75Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,328.34A41.91,41.91,0,0,1,265.4,318.2c8.18-2.65,32.41-7.7,38.84-10.06a53.88,53.88,0,0,0,19-12l28.44,23.36A88,88,0,0,1,335.48,331c-9.16,4.92-31.72,4.94-43.87,12.23-7.87,4.72-18.06,18.55-18.06,18.55Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.38,298.54h0c-.1.07-9.91,7.82-16.42,10.2-4.57,1.67-12.82,3.76-20.81,5.78-6,1.53-11.77,3-15.74,4.2-12.7,3.91-17.15,9.32-17.33,9.55l-.43.52L273,357.61l.74-1c.08-.11,7.77-10.23,13.87-14,8.11-5,16.72-6.33,25.05-7.6,6-.91,11.58-1.77,17.06-3.86a68.68,68.68,0,0,0,13.83-7.2,44,44,0,0,0,5-3.8l.76-.71ZM286.63,341.1c-3.63,2.24-7.66,6.46-10.53,9.76a4.53,4.53,0,0,0-2.5-2c-1.85-.24-2.77,1-2.68,2.76l-13.19-18.72.18,0c3.2-.77,2.47-5.1,0-6.37l.19-.14a47.62,47.62,0,0,1,12.83-5.89c3.93-1.21,9.63-2.65,15.66-4.18l2.07-.52c-2.26,2.12-3.09,5.81.15,10.91,3,4.71,8.53,7.45,13.21,8.43A49,49,0,0,0,286.63,341.1ZM329,329.48c-5.29,2-10.82,2.87-16.68,3.77l-1.66.25a9.72,9.72,0,0,0,.3-11.71c-2.77-3.64-7.14-7.84-13-8.47,3.81-1,7.18-2,9.58-2.89,4.57-1.67,10.65-5.27,14.2-7.49a2,2,0,0,0,1.85,2.22c1.11.22,2.76-.23,3-1.5a1.08,1.08,0,0,0,0-.18L344,317.54c-3.17-.16-3.11,3.39-.18,4A65.7,65.7,0,0,1,329,329.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.15,329l1.27,1.75-1.39,1-1.24-1.71a7.64,7.64,0,0,1-4.39,1.27l-.61-2.47a6.52,6.52,0,0,0,3.51-.85l-1.89-2.62c-1.86.7-4,1.38-5.63-.86-1.2-1.67-1.16-3.87.84-5.75l-1.26-1.74,1.4-1,1.24,1.71a7.14,7.14,0,0,1,3.52-1.1l.7,2.43a6.59,6.59,0,0,0-2.73.73l1.93,2.67c1.85-.72,4-1.37,5.57.84C307.17,325,307.13,327.15,305.15,329Zm-6.41-5.92-1.61-2.23a1.45,1.45,0,0,0-.19,1.91C297.33,323.35,298,323.34,298.74,323.12Zm5.14,2c-.4-.55-1-.56-1.79-.36l1.56,2.17A1.38,1.38,0,0,0,303.88,325.16Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.6,40.21l-34-4.57L214,36c-6.16.84-11.08,2.33-18.41,10.09-7.13,7.55-10.13,26.84-10.13,26.84s8.46-4.35,21.49-4.06,17.77,2.57,17.77,2.57.09-13,5.66-19.52C237.34,43.83,251.6,40.21,251.6,40.21Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M251.6,40.21l-34-4.57L214,36c-6.16.84-11.08,2.33-18.41,10.09-7.13,7.55-10.13,26.84-10.13,26.84s8.46-4.35,21.49-4.06,17.77,2.57,17.77,2.57.09-13,5.66-19.52C237.34,43.83,251.6,40.21,251.6,40.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214,36s8-1.13,20.66,9.75c8.1,6.94,22,28.23,22,28.23a36.41,36.41,0,0,1,10.76-9.81c11.29-6.69,17.76-8.38,17.76-8.38S278,45,267.21,40.75C241.17,30.44,214,36,214,36Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.56,34.7c1.77.94,12.22,4.64,19.45,4s9-1.81,6.08-2.57a52.21,52.21,0,0,0-12.42-1.68A107.76,107.76,0,0,0,224.56,34.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.4,53.5A73.08,73.08,0,0,0,265,40.56c-1.28-.7-2.64-1.37-4-2a92.48,92.48,0,0,0-14.22-3.12c4.56,1,10.47,1.48,18.07,6.7a104.91,104.91,0,0,1,10.86,8.68c-1.19.69-1.21,3.07-.36,4a49.84,49.84,0,0,0-8.95,4.53,85.47,85.47,0,0,0-7.49,5.56,2.69,2.69,0,0,0,.24-1.43c-.28-1.58-2.51-2.61-4-2.17a1.64,1.64,0,0,0-1.29,1.14c-4.28-6.23-11.39-16.14-15.49-19.58a55.26,55.26,0,0,0-13.66-8.14l-.11,0c-1.76.11-3.15.3-4.53.45a54.37,54.37,0,0,1,17,9.29c5.79,4.86,18.52,24.21,18.65,24.41l.66,1,.88-.8a99.24,99.24,0,0,1,10.3-8,47,47,0,0,1,13.38-5.88l1.73-.39Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.73,281.66l30.77,5.25,3.23-.22c5.62-.56,10.13-1.75,17-8.56,6.72-6.63,10.06-24,10.06-24s-7.82,3.68-19.64,3-16.05-2.91-16.05-2.91-.5,11.83-5.77,17.54C140.8,278.83,127.73,281.66,127.73,281.66Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.73,281.66l30.77,5.25,3.23-.22c5.62-.56,10.13-1.75,17-8.56,6.72-6.63,10.06-24,10.06-24s-7.82,3.68-19.64,3-16.05-2.91-16.05-2.91-.5,11.83-5.77,17.54C140.8,278.83,127.73,281.66,127.73,281.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M161.73,286.69s-7.28.77-18.45-9.51c-7.13-6.56-19-26.35-19-26.35a33.06,33.06,0,0,1-10.08,8.57c-10.46,5.71-16.4,7-16.4,7s6.13,10,15.79,14.24C136.88,290.87,161.73,286.69,161.73,286.69Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.1,287.54c-1.58-.92-10.94-4.61-17.53-4.23s-8.19,1.35-5.6,2.14a47.92,47.92,0,0,0,11.22,1.93A99.11,99.11,0,0,0,152.1,287.54Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.1,268.64a66.82,66.82,0,0,0,14.46,12.27c1.14.68,2.35,1.33,3.6,1.94a82.78,82.78,0,0,0,12.81,3.3c-4.11-1.09-9.46-1.69-16.2-6.67a98.18,98.18,0,0,1-9.58-8.23c1.1-.59,1.2-2.75.46-3.62a44.56,44.56,0,0,0,8.27-3.83,75.94,75.94,0,0,0,7-4.8,2.41,2.41,0,0,0-.26,1.29c.2,1.44,2.19,2.45,3.58,2.1a1.53,1.53,0,0,0,1.22-1c3.68,5.79,9.81,15,13.43,18.28A50,50,0,0,0,152,287.5l.09,0c1.61-.05,2.88-.18,4.13-.27a49.24,49.24,0,0,1-15.12-9c-5.1-4.59-16-22.58-16.14-22.76l-.57-.93-.83.7a87.52,87.52,0,0,1-9.6,6.9,42.49,42.49,0,0,1-12.34,4.91l-1.58.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.18,100.3s7.19-5.85,16.34-14.58c11.16-10.64,34.3-31.84,54-23.82l22.59,27s-11-2.29-25.8,3.18C402.2,96.93,393,106.57,388.85,111c-1.67,1.79-3.86,4.19-5.62,5.88-3,2.84-6.35,6.78-11.66,11.06Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.87,80.63c2.61,6.19-.55,13.42-7.06,16.17s-13.9,0-16.51-6.22.56-13.42,7.07-16.16S399.27,74.45,401.87,80.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395.65,88.9,397,90.22,396,91.3,394.64,90a6.68,6.68,0,0,1-3.59,1.75l-.9-2a5.71,5.71,0,0,0,2.9-1.25l-2-2c-1.5.88-3.25,1.78-5,.09-1.29-1.25-1.58-3.15-.14-5.07l-1.34-1.31,1.05-1.08,1.32,1.29a6.37,6.37,0,0,1,2.88-1.48l1,2a5.94,5.94,0,0,0-2.24,1l2.06,2c1.49-.89,3.22-1.77,4.93-.1C396.79,85.1,397.08,87,395.65,88.9Zm-6.4-4.14-1.72-1.68a1.26,1.26,0,0,0,.11,1.67C388.07,85.17,388.61,85.07,389.25,84.76Zm4.73,1c-.43-.42-1-.33-1.6,0l1.67,1.63A1.2,1.2,0,0,0,394,85.75Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.84,62.12l-.23-.07c-.58-.19-14.29-4.3-33.65,10.49a168.13,168.13,0,0,0-20.25,18.29c-4,4.12-6.87,7.09-10.35,8.93l-.92.48L372,125.78l.67-.74c.2-.21,19.37-21.31,28.59-27.82,7.31-5.16,21.49-13.42,34.22-10.76L438,87ZM400.31,95.83c-6.66,4.69-18,16.44-24.33,23.16a5.35,5.35,0,0,0-7.34-.14l-11.27-14a4.5,4.5,0,0,0,1.87-3.46,6.48,6.48,0,0,0-1.06-3.71c1.79-1.58,3.62-3.46,5.76-5.67A164.68,164.68,0,0,1,384,73.9c9.73-7.43,17.94-9.81,23.11-10.5a30,30,0,0,1,4.07-.28,7.71,7.71,0,0,0,7.76,4.11l11.78,13.86c-.82.26-1.79,1-1.52,3.17C417.87,84.71,406.61,91.38,400.31,95.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.53,358.63s7.18,5.86,17.58,13.05c12.69,8.78,38.13,27.15,34.28,48.1L91.53,447.36s0-11.28-8.33-24.62c-7.44-11.89-18.74-19-23.9-22.12-2.09-1.27-4.88-2.93-6.9-4.31-3.37-2.31-7.92-4.85-13.18-9.18Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.4,
    cy: 396.7,
    rx: 12.15,
    ry: 12.79,
    transform: "translate(-210.1 117.85) rotate(-34.55)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.19,402.74l-1,1.6-1.27-.81,1-1.56a6.66,6.66,0,0,1-2.43-3.16l1.81-1.29a5.79,5.79,0,0,0,1.82,2.59l1.52-2.39c-1.17-1.28-2.4-2.82-1.1-4.85,1-1.52,2.77-2.19,4.95-1.16l1-1.58,1.27.81-1,1.55a6.31,6.31,0,0,1,2,2.52L89,396.36a5.77,5.77,0,0,0-1.47-2L86,396.8c1.17,1.27,2.39,2.79,1.1,4.8C86.14,403.08,84.36,403.75,82.19,402.74Zm2.75-2.28c.32-.5.12-1-.29-1.57l-1.26,2A1.21,1.21,0,0,0,84.94,400.46Zm0-4.83,1.29-2a1.28,1.28,0,0,0-1.61.46C84.31,394.56,84.52,395.07,85,395.63Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.82,418.14l0-.25c.07-.6,1.32-14.86-17.09-30.82a168.31,168.31,0,0,0-22-16.13c-4.84-3.07-8.33-5.29-10.83-8.33l-.67-.8L41.4,387.16l.86.5c.25.15,24.8,14.65,33,22.36,6.53,6.12,17.49,18.33,17.47,31.34v2.49Zm-36.36-9.37c-5.94-5.56-19.74-14.31-27.61-19.13a5.35,5.35,0,0,0-1.34-7.21l11.41-13.88a4.49,4.49,0,0,0,3.77,1.13,6.33,6.33,0,0,0,3.41-1.79c1.91,1.44,4.13,2.85,6.73,4.5a165.58,165.58,0,0,1,21.8,16c9.25,8,13.25,15.58,15,20.51a29.55,29.55,0,0,1,1.09,3.93,7.71,7.71,0,0,0-2.45,8.42L97.05,435.57c-.41-.75-1.35-1.55-3.41-.85C90.9,423.72,82.1,414.05,76.46,408.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14,193.05S30,174.38,61.26,186.4a19.69,19.69,0,0,0,3.67,1,20.34,20.34,0,0,0,10.69-.76c6.1-2.45,14.77-6,14.77-6l26.83,15.88s-11.25,8.2-22.14,8.89-23.76-8.25-36.25-5.2a31.33,31.33,0,0,0-16.5,9.49Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.68,197.16c-1.21,1.08-8.47.09-16.23-2.21s-13.07-5-11.86-6.13,8.47-.09,16.23,2.22S79.88,196.08,78.68,197.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.86,195.07l.49.52-1.63-.36-.48-.51a42.6,42.6,0,0,1-4.41-1.26l.36-.37c1,.35,2.27.73,3.47,1l-.73-.77c-1.93-.53-4.12-1.14-4.75-1.81-.46-.49.39-.64,2.89-.16l-.49-.51,1.63.35.48.51c1.25.3,2.53.65,3.58,1l-.28.4c-.95-.32-1.88-.59-2.72-.79l.75.79c1.92.52,4.08,1.13,4.7,1.78C71.18,195.4,70.34,195.54,67.86,195.07Zm-3.58-2.42-.63-.66c-.81-.13-1-.07-.88.08A4.87,4.87,0,0,0,64.28,192.65Zm3.87,1.74a4.7,4.7,0,0,0-1.48-.58l.61.64C68,194.58,68.29,194.54,68.15,194.39Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90,182.57l-.3.14a93.66,93.66,0,0,1-15.67,6c-3.75,1-5.5.65-8.69.09l-2-.34a41.14,41.14,0,0,1-5.51-1.54c-4-1.3-9.09-2.92-14.13-3.08h-.13c-.14,0-14-1.2-25.29,7.87l-.67.54,24.1,14.59.33-.31c.13-.12,13.06-11.8,30.54-7.4,2.07.52,4,1,5.8,1.51,14.16,3.74,21.26,5.62,35.5-2.93l.86-.52ZM78.68,199.46c-1.81-.48-3.74-1-5.81-1.51-11.89-3-21.74,1.2-27.15,4.47-4-2.1-6.77-.21-7.79.71l-14.1-8.53c2.72-2.37,1.13-4.42.21-5.27A38.54,38.54,0,0,1,43.49,185c4.95.14,9.95,1.74,14,3a43.07,43.07,0,0,0,5.69,1.58l2,.34c3.24.57,5.2.9,9.19-.11a82.85,82.85,0,0,0,11.84-4.21c1,.87,3.67,2.52,7.62.55l14.38,8.5c-1.08.51-2.69,1.84-.12,4.74C97.48,204.43,90.67,202.63,78.68,199.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380,445s-1.89-24.47,28.79-38a19.87,19.87,0,0,0,3.34-1.86,20.3,20.3,0,0,0,7-8.07c2.59-6,6.22-14.7,6.22-14.7l30.21-7.68s-2.18,13.75-9.41,21.92-22.66,10.92-29.36,21.9a31.35,31.35,0,0,0-5,18.36Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.74,402.33c-.09,1.62-5.94,6-13.06,9.88s-12.82,5.65-12.73,4,5.94-6,13.06-9.88S428.83,400.71,428.74,402.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.59,408.48l.72,0-1.41.9-.7,0a41.59,41.59,0,0,1-4,2.21v-.51a34.42,34.42,0,0,0,3.19-1.73l-1.08,0c-1.73,1-3.71,2.09-4.63,2.07-.68,0-.18-.73,1.93-2.15l-.71,0,1.41-.9.7,0c1.09-.67,2.25-1.32,3.25-1.8l.08.47c-.9.45-1.74.91-2.49,1.36l1.09,0c1.73-1,3.69-2.08,4.59-2C422.18,406.37,421.68,407.07,419.59,408.48Zm-4.24.81-.91,0c-.67.47-.78.67-.56.67A4.76,4.76,0,0,0,415.35,409.29Zm4-1.49a4.76,4.76,0,0,0-1.46.63l.89,0C419.38,408,419.53,407.8,419.32,407.8Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.49,384l-.1.31a94.71,94.71,0,0,1-6.89,15.31c-2,3.31-3.44,4.34-6.09,6.2-.52.36-1.08.75-1.69,1.19a42.1,42.1,0,0,1-5,2.8c-3.79,1.94-8.51,4.34-12.19,7.79l-.09.09c-.11.09-10.78,9-12.37,23.42l-.1.86,27.38-6.67,0-.45c0-.18.93-17.58,16.41-26.8,1.84-1.09,3.56-2.08,5.17-3,12.68-7.33,19-11,23.09-27.12l.25-1Zm3.87,20c-1.62.94-3.35,1.93-5.18,3-10.53,6.27-14.56,16.18-16.09,22.32a6.52,6.52,0,0,0-5,6l-16,3.89c.25-3.6-2.32-3.93-3.57-3.88a38.4,38.4,0,0,1,10.75-16.77c3.6-3.39,8.27-5.79,12-7.7a43.68,43.68,0,0,0,5.15-2.9c.6-.44,1.16-.83,1.67-1.19,2.7-1.89,4.32-3,6.44-6.56A83.09,83.09,0,0,0,426,388.87c1.33-.1,4.38-.8,5.78-5l16.19-4.11c-.4,1.11-.61,3.19,3.25,3.44C447.19,394.21,441.09,397.75,430.36,404Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M424.77,202.81s-6.8-23.59,20.49-43.09a19.15,19.15,0,0,0,2.9-2.49,20.23,20.23,0,0,0,5.25-9.33c1.32-6.44,3.12-15.65,3.12-15.65l28-13.64s.64,13.9-4.78,23.37-20,15.28-24.32,27.39a31.36,31.36,0,0,0-1.17,19Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.84,151.12c.24,1.6-4.59,7.12-10.79,12.32s-11.41,8.12-11.65,6.52,4.6-7.12,10.79-12.32S463.6,149.51,463.84,151.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M456.13,159l.71-.13-1.2,1.17-.69.12a39.46,39.46,0,0,1-3.49,3l-.11-.5a35.39,35.39,0,0,0,2.77-2.33l-1.05.18c-1.5,1.32-3.22,2.81-4.12,3-.67.11-.32-.68,1.46-2.5l-.71.13,1.2-1.17.69-.12c.94-.88,1.94-1.75,2.82-2.43l.17.45c-.79.62-1.52,1.25-2.16,1.83l1.08-.19c1.49-1.32,3.19-2.78,4.08-2.93C458.23,156.4,457.89,157.18,456.13,159Zm-4,1.66-.9.15c-.55.61-.62.82-.41.78A4.83,4.83,0,0,0,452.14,160.65Zm3.58-2.27a4.6,4.6,0,0,0-1.3.91l.88-.15C455.83,158.57,455.92,158.34,455.72,158.38Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.92,133.6l0,.32a95,95,0,0,1-3.64,16.38c-1.27,3.65-2.49,4.95-4.71,7.3-.44.47-.91,1-1.42,1.52a41.5,41.5,0,0,1-4.31,3.75c-3.33,2.67-7.46,6-10.36,10.1l-.08.1c-.08.11-8.72,11.05-7.37,25.44l.08.86,25.46-12.07-.07-.45c0-.17-2.65-17.4,10.65-29.56,1.57-1.44,3.06-2.76,4.45-4,10.93-9.75,16.41-14.64,17.12-31.23l0-1Zm7.84,18.78c-1.4,1.25-2.89,2.58-4.46,4-9.05,8.27-11,18.8-11.24,25.11a6.5,6.5,0,0,0-3.69,6.9l-14.89,7.06c-.48-3.57-3.07-3.38-4.28-3.08a38.33,38.33,0,0,1,7.13-18.6c2.84-4,6.93-7.34,10.22-10a41.79,41.79,0,0,0,4.46-3.88c.5-.55,1-1,1.39-1.5,2.26-2.39,3.62-3.84,5-7.73a84,84,0,0,0,3-12.2c1.29-.37,4.13-1.67,4.65-6.06l15-7.31c-.16,1.18.06,3.25,3.89,2.72C480.27,139.43,475,144.13,465.76,152.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.88,122.79a41.94,41.94,0,0,1-18.36-5.92c-7.31-4.52-26.86-19.7-32.82-23.07a75.35,75.35,0,0,0-21.44-8l-.61-35.47a88.37,88.37,0,0,1,19.23,4.87c9.68,3.79,24.32,21,37.74,25.49,8.7,2.94,25.83,1.73,25.83,1.73Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,84.36l.64.19c.12,0,11.77,3.37,17.79,6.79,4.24,2.4,11.18,7.33,17.89,12.1,5.09,3.62,9.9,7,13.4,9.27,11.21,7.14,18.21,7,18.51,7l.67,0,8.79-34.15-1.23.07c-.13,0-12.83.71-19.65-1.49-9.08-2.92-15.66-8.63-22-14.16-4.55-3.94-8.84-7.67-14-10.48A68.67,68.67,0,0,0,70.3,53.62a43.62,43.62,0,0,0-6.11-1.3l-1-.12Zm56.26,1.5c4.05,1.3,9.88,1.64,14.25,1.69a4.62,4.62,0,0,0,.07,3.22c1,1.56,2.58,1.44,3.84.25l-5.7,22.18-.14-.12c-2.66-1.94-5.49,1.43-4.86,4.12l-.23-.06a47.47,47.47,0,0,1-12.8-6c-3.47-2.21-8.26-5.61-13.33-9.22l-1.74-1.24c3.08.35,6.43-1.41,8.21-7.18,1.65-5.34.15-11.32-2.13-15.52A49.15,49.15,0,0,0,120.21,85.86ZM83.88,61.08c5,2.72,9.2,6.38,13.67,10.27.43.36.85.73,1.27,1.1a9.71,9.71,0,0,0-9.11,7.36c-1,4.46-1.34,10.52,2,15.39C88.43,93,85.5,91,83.27,89.77c-4.23-2.4-10.92-4.7-14.9-6A2,2,0,0,0,68.86,81c-.56-1-2-2-3.08-1.31l-.14.11-.55-22.34c1.93,2.51,4.6.17,3.18-2.47A65.85,65.85,0,0,1,83.88,61.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99,79.64l.51-2.11,1.68.41-.5,2a7.6,7.6,0,0,1,3.8,2.52L103,84.58a6.58,6.58,0,0,0-2.92-2.13l-.77,3.14c1.74,1,3.64,2.16,3,4.85-.49,2-2.2,3.39-4.93,3.08l-.5,2.09-1.68-.41.5-2a7.21,7.21,0,0,1-3.12-2L94,89.07a6.63,6.63,0,0,0,2.33,1.6l.78-3.2c-1.74-.94-3.62-2.13-3-4.78C94.58,80.73,96.26,79.35,99,79.64Zm-2.13,3.48c-.16.66.24,1.13.89,1.59l.63-2.59A1.37,1.37,0,0,0,96.85,83.12Zm1.78,5.23L98,91a1.45,1.45,0,0,0,1.58-1.09C99.71,89.28,99.3,88.8,98.63,88.35Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.61,452.24a41.82,41.82,0,0,1-18.35-5.93c-7.32-4.51-26.87-19.69-32.83-23.06a75.35,75.35,0,0,0-21.43-8l-.62-35.47a87.56,87.56,0,0,1,19.23,4.87c9.68,3.79,24.32,20.95,37.75,25.49,8.69,2.93,25.82,1.73,25.82,1.73Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.68,413.81l.64.18c.12,0,11.78,3.38,17.8,6.8,4.23,2.4,11.17,7.33,17.88,12.1,5.09,3.62,9.9,7,13.41,9.27,11.2,7.14,18.21,7,18.5,7l.68,0L292.37,415l-1.23.07c-.13,0-12.82.71-19.65-1.49-9.08-2.92-15.66-8.63-22-14.16-4.55-3.94-8.85-7.67-14-10.48A68.46,68.46,0,0,0,221,383.07a43.62,43.62,0,0,0-6.11-1.3l-1-.12Zm56.26,1.5c4.06,1.3,9.88,1.64,14.26,1.69a4.62,4.62,0,0,0,.07,3.22c1,1.56,2.58,1.44,3.84.25l-5.71,22.18-.14-.12c-2.65-1.94-5.48,1.43-4.85,4.12l-.23-.06a47.2,47.2,0,0,1-12.8-5.95c-3.47-2.21-8.26-5.61-13.33-9.22l-1.75-1.24c3.09.35,6.43-1.41,8.21-7.18,1.65-5.34.16-11.32-2.13-15.52A49.15,49.15,0,0,0,270.94,415.31Zm-36.33-24.78c5,2.71,9.2,6.38,13.68,10.26.42.37.84.74,1.27,1.1a9.74,9.74,0,0,0-9.12,7.37c-1,4.46-1.34,10.52,2,15.38-3.24-2.23-6.18-4.16-8.4-5.42-4.24-2.4-10.92-4.7-14.91-6a2,2,0,0,0,.5-2.85c-.56-1-2-2-3.09-1.3l-.14.11-.54-22.35c1.93,2.52,4.59.18,3.17-2.46A65.53,65.53,0,0,1,234.61,390.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.71,409.08l.52-2.1,1.67.41-.5,2.05a7.55,7.55,0,0,1,3.81,2.52L253.73,414a6.53,6.53,0,0,0-2.93-2.13L250,415c1.74,1,3.65,2.16,3,4.85-.48,2-2.19,3.39-4.92,3.08l-.51,2.09-1.67-.41.5-2a7.17,7.17,0,0,1-3.13-2l1.41-2.1a6.6,6.6,0,0,0,2.32,1.6l.78-3.2c-1.74-.94-3.61-2.13-3-4.78C245.31,410.18,247,408.8,249.71,409.08Zm-2.13,3.49c-.16.66.24,1.13.89,1.59l.64-2.59A1.38,1.38,0,0,0,247.58,412.57Zm1.78,5.23-.65,2.67a1.46,1.46,0,0,0,1.58-1.09C250.45,418.72,250,418.24,249.36,417.8Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.63,162.46c-6.39.16-18.13-.09-29.23-5.18-13.75-6.31-19.7-15.36-19.7-15.36l-3,33.69c8,18.86,39.79,20.16,54.61,20.51C212.39,179.8,211.37,172.13,213.63,162.46Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.19,
    cy: 178.83,
    rx: 11.68,
    ry: 12.3,
    transform: "translate(-42.68 294.26) rotate(-67.9)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.65,172.85l0-1.82,1.45,0,0,1.78a6.39,6.39,0,0,1,3.63,1.25l-.77,2a5.4,5.4,0,0,0-2.83-1.12l0,2.71c1.61.42,3.42,1,3.45,3.33,0,1.72-1.08,3.21-3.36,3.54l0,1.8-1.45,0,0-1.77a6.14,6.14,0,0,1-3-1l.7-2a5.56,5.56,0,0,0,2.23.81l0-2.76c-1.61-.4-3.39-1-3.42-3.28C192.3,174.67,193.38,173.19,195.65,172.85Zm-1,3.29c0,.57.43.87,1.06,1.11l0-2.25C195,175.19,194.65,175.62,194.65,176.14ZM197.2,180l0,2.3a1.21,1.21,0,0,0,1.05-1.21C198.28,180.55,197.84,180.24,197.2,180Z",
    style: {
      fill: "#35A464"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.43,192.31A119.79,119.79,0,0,1,193.3,191c-11.67-1.56-18.87-5.52-22.86-8.57a29.19,29.19,0,0,1-2.95-2.57,7.41,7.41,0,0,0-2.48-8.06l1.4-17.43c.73.38,1.9.53,3.19-1.13,8,7.39,20.19,10.51,27.5,11.76a111.39,111.39,0,0,0,15.84,1l.31-1.77a113.65,113.65,0,0,1-15.79-.9c-8.48-1.46-23.73-5.47-30.58-15.92l-1.32-2-2.51,31.24.11.21c.26.52,6.79,12.63,30,15.73a123.74,123.74,0,0,0,22.55,1.36Z",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknotePana);
export default __webpack_public_path__ + "static/media/banknote-pana.45a78f58beac6d77e9a1854f4baf01ea.svg";
export { ForwardRef as ReactComponent };